import React from 'react';
import {
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import {
  ApiBlueprint,
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

import { rootRouteRef } from './routes';
import { techDebtApiRef, TechDebtClient } from './api';

const techDebtPage = PageBlueprint.make({
  name: 'tech-debt',
  params: {
    routeRef: rootRouteRef,
    path: '/tech-debt',
    loader: () =>
      import('./components/TechDebtPage').then(m => <m.TechDebtPage />),
  },
});

const techDebtApi = ApiBlueprint.make({
  name: 'techdebt-api',
  params: defineParams =>
    defineParams({
      api: techDebtApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new TechDebtClient({ discoveryApi, fetchApi }),
    }),
});

export const techdebtFrontendPlugin = createFrontendPlugin({
  pluginId: 'techdebt',
  extensions: [techDebtPage, techDebtApi],
  routes: {
    root: rootRouteRef,
  },
});
